
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import Form1ProcessHeader from "@/components/process/Form1/components/Form1ProcessHeader.vue";
import { accountInfoType, userAccessInfoType, form1StatusInfoType, accountUserInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        Form1ProcessHeader
    }
})
export default class AccessForm1 extends Vue {

    @commonState.State
    public accountInfo!: accountInfoType;

    @form1State.State
    public form1AccessInfo!: userAccessInfoType[];

    @form1State.State
    public currentNoticeOfAppealId: string;

    @form1State.Action
    public UpdateForm1AccessInfo!: (newForm1AccessInfo: userAccessInfoType[]) => void;

    stepsCompleted = {} as form1StatusInfoType;
    selectedUser = {} as accountUserInfoType;
    accessInfo: userAccessInfoType[] = [];
    nonAdminUsers: accountUserInfoType[] = [];
    enableAddUser = false;
    dataReady = false; 
    updated = 0;
    
    userFields = [
        {
            key:'user',          
            label:'User',                  
            thClass: 'border-dark border-bottom text-primary bg-light',            
            sortable:false            
        },
        {
            key:'readOnly',          
            label:'Read Only Access',                  
            thClass: 'border-dark border-bottom text-primary bg-light',            
            sortable:false            
        },
        {
            key:'update',          
            label:'Read/Write Access',                  
            thClass: 'border-dark border-bottom text-primary bg-light',
            sortable:false            
        },
        {
            key:'remove',          
            label:'',  
            thClass: 'border-dark border-bottom text-primary bg-light', 
            sortable:false            
        }
    ]   

    mounted() {  
        this.dataReady = false;

        if (this.currentNoticeOfAppealId && this.form1AccessInfo && this.form1AccessInfo.length > 0){
            this.accessInfo = this.form1AccessInfo;
        } else {
            this.extractAccessInfo();
        }

        this.dataReady = true;       
    }

    public extractAccessInfo(){

        for (const userInfo of this.accountInfo.accountUsers){
            if(userInfo.isAdmin){
                const userAccessInfo = {user: userInfo, readOnly: false, update: true, default: true}
                userAccessInfo.user.displayName = userInfo.fullName + ((userInfo.clientId == this.accountInfo.clientId)?' (yourself)':' (account admin)');
                this.accessInfo.push(userAccessInfo)
            } else if(userInfo.clientId == this.accountInfo.clientId){

                const userAccessInfo = {user: userInfo, readOnly: true, update: false, default: true}
                userAccessInfo.user.displayName = userInfo.fullName + ((userInfo.clientId == this.accountInfo.clientId)?' (yourself)':''); 
                this.accessInfo.push(userAccessInfo)

            } else {
                this.nonAdminUsers.push(userInfo);
            }
        }

    }

    public showUserDropdown() {
        this.enableAddUser = true;        
    }

    public addUser() {
        
        const userIndex = this.accessInfo.findIndex(info => info.user.clientId == this.selectedUser.clientId);        
        if (userIndex == -1){
            const addedUser = this.accountInfo.accountUsers.filter(user => user.clientId == this.selectedUser.clientId)[0]
            addedUser.displayName = addedUser.fullName;            
            this.accessInfo.push({user: addedUser, readOnly: false, update: true, default: false});              
        }
        
        this.selectedUser = {} as accountUserInfoType;     
    }

    public removeUser(userToRemove) {        
        const userIndex = this.accessInfo.findIndex(info => info.user.clientId == userToRemove.clientId)       
        this.accessInfo.splice(userIndex, 1);        
    }

    public makeUserReadOnly(userInfo){
        const userIndex = this.accessInfo.findIndex(info => info.user.clientId == userInfo.clientId)        
        this.accessInfo[userIndex].readOnly = true;
        this.accessInfo[userIndex].update = false;
        this.updated++;
    }

    public makeUserReadWrite(userInfo){
        const userIndex = this.accessInfo.findIndex(info => info.user.clientId == userInfo.clientId)
        this.accessInfo[userIndex].readOnly = false;
        this.accessInfo[userIndex].update = true;
        this.updated ++;
    }

    public navigateToForm1() {
        this.UpdateForm1AccessInfo(this.accessInfo);
        this.$router.push({name: "start-form1"});
    } 

}
